var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2488 30.3092C16.1223 30.45 15.9007 30.45 15.7742 30.3092L2.93851 16.03C2.84174 15.9223 2.83039 15.7632 2.91089 15.6431L6.63717 10.0806C6.69622 9.99244 6.79564 9.93953 6.90211 9.93953H16.0115H25.1209C25.2273 9.93953 25.3267 9.99244 25.3858 10.0806L26.1758 9.55664L25.3858 10.0806L29.1121 15.6431C29.1926 15.7632 29.1812 15.9223 29.0845 16.03L16.2488 30.3092Z",
    stroke: "#161616",
    strokeWidth: 1.77343
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79102 15.9617H10.1592L16.2487 10.3379L22.5771 15.9617H27.9104",
    stroke: "#161616",
    strokeWidth: 1.77343,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17969 10.5352L15.8961 30.4956",
    stroke: "#161616",
    strokeWidth: 1.77343,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2105 10.7773L16.0879 30.5178",
    stroke: "#161616",
    strokeWidth: 1.77343,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1988 15.9199H6.06445",
    stroke: "#161616",
    strokeWidth: 1.77343,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2061 3.04102L20.709 5.43367",
    stroke: "#161616",
    strokeWidth: 1.47786,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48633 3.04102L10.9835 5.43367",
    stroke: "#161616",
    strokeWidth: 1.47786,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9127 3.60806L15.8203 0.791016",
    stroke: "#161616",
    strokeWidth: 1.47786,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.a19d18ed3fed899816535202f6c56ba1.svg";
export { ForwardRef as ReactComponent };